import type { NavigationEntry } from "@positive/ui";
import "@ui5/webcomponents-icons/dist/journey-arrive.js";
import "@ui5/webcomponents-icons/dist/journey-depart.js";
import "@ui5/webcomponents-icons/dist/receipt.js";
import "@ui5/webcomponents-icons/dist/time-entry-request.js";
import "@ui5/webcomponents-icons/dist/lead.js";
import "@ui5/webcomponents-icons/dist/split.js";
import "@ui5/webcomponents-icons/dist/marketing-campaign.js";
import "@ui5/webcomponents-icons/dist/business-objects-experience.js";
import "@ui5/webcomponents-icons/dist/settings.js";

import { parkingPermissions, parkingSettingsGroup } from "./permissions";

/** Parking entries of the navigation registry (group `parking`, docs/contracts/parking.md §5). */
export const parkingNavigation: readonly NavigationEntry[] = [
  {
    key: "parking.entry",
    labelKey: "nav.parkingEntry",
    icon: "journey-arrive",
    path: "/parking/entry",
    permission: parkingPermissions.entryCreate,
  },
  {
    key: "parking.exit",
    labelKey: "nav.parkingExit",
    icon: "journey-depart",
    path: "/parking/exit",
    permission: parkingPermissions.exitView,
  },
  {
    key: "parking.tickets",
    labelKey: "nav.parkingTickets",
    icon: "receipt",
    path: "/parking/tickets",
    permission: parkingPermissions.entryView,
  },
  {
    key: "parking.shifts",
    labelKey: "nav.parkingShifts",
    icon: "time-entry-request",
    path: "/parking/shifts",
    permission: parkingPermissions.shiftView,
  },
  {
    key: "parking.tariffs",
    subGroup: "setup",
    labelKey: "nav.parkingTariffs",
    icon: "lead",
    path: "/parking/tariffs",
    permission: parkingPermissions.tariffView,
  },
  {
    key: "parking.lanes",
    subGroup: "setup",
    labelKey: "nav.parkingLanes",
    icon: "split",
    path: "/parking/lanes",
    permission: parkingPermissions.moduleView,
  },
  {
    key: "parking.campaigns",
    labelKey: "nav.parkingCampaigns",
    icon: "marketing-campaign",
    path: "/parking/campaigns",
    permission: parkingPermissions.campaignView,
  },
  {
    key: "parking.reports",
    labelKey: "nav.parkingReports",
    icon: "business-objects-experience",
    path: "/parking/reports",
    permission: parkingPermissions.reportView,
  },
  {
    key: "parking.settings",
    subGroup: "setup",
    labelKey: "nav.parkingSettings",
    icon: "settings",
    path: `/platform/settings/${parkingSettingsGroup}`,
    permission: parkingPermissions.setupView,
  },
];
